export default __webpack_public_path__ + "static/media/SE.24401a6f.svg";